import React from "react";
import Layout from "../components/layout";
import Seo from "../components/head";
import ContactPageContent from "../components/contact/contact-page";

const ContactPage = () => {
  return (
    <Layout>
      <ContactPageContent />
    </Layout>
  );
};

export default ContactPage;

export const Head = () => <Seo title="Contact" />;